import React, { useState, useEffect } from 'react';
import ImageList from './ImageList';
import PaginationGroup from '../../common/PaginationGroup';
import { getUserImages, getAllTaxonomy } from '../../api/';
import './styles.scss';

function Tagging() {
    const listSize = 10;
    const [currentPage, setCurrentPage] = useState(1);
    const [userImages, setUserImages] = useState(null);
    const [maxPage, setMaxPage] = useState(1);
    const [taxonomy, setTaxonomy] = useState({});

    useEffect(() => {
        const fetchUserImages = async () => {
            const skip = (currentPage - 1) * listSize;
            const resultImages = await getUserImages(skip, listSize);

            if (resultImages && resultImages.images.length > 0) {
                setUserImages(resultImages.images);
                setMaxPage(Math.ceil(resultImages.count / listSize));
            }
        };

        const fetchAllTaxonomy = async () => {
            const allTaxonomy = await getAllTaxonomy();

            if (allTaxonomy) {
                setTaxonomy(allTaxonomy);
            }
        };

        fetchUserImages();
        fetchAllTaxonomy();
    }, [currentPage, listSize]);

    function next() {
        setCurrentPage(Math.min(currentPage + 1, maxPage));
    }

    function prev() {
        setCurrentPage(Math.min(currentPage - 1, 1));
    }

    function jump(page) {
        setCurrentPage(Math.min(page, maxPage));
    }

    return (
        <div>
            <div className="mt-4 col-12 d-inline-flex justify-content-between">
                <h1 className="p-0 mt-0">Tag Toolkit Beta</h1>
                <div>
                    <a
                        href="https://litterati.notion.site/litterati/Getting-Started-Tag-Toolkit-54617aa23e384de3b3071717f1574e15"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-primary mx-4"
                    >
                        How To Tag
                    </a>
                    <a
                        href="https://litterati.notion.site/litterati/Welcome-to-Litterati-s-Labeling-Guide-6467b8e02657465a8ae63d9913ed567f"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-primary"
                    >
                        Labeling Guide
                    </a>
                </div>
            </div>
            {userImages && (
                <>
                    <div className="col-12 my-4">
                        <PaginationGroup
                            maxPage={maxPage}
                            currentPage={currentPage}
                            handlePrevious={prev}
                            handleNext={next}
                            handleJump={jump}
                        />
                        {userImages && (
                            <ImageList
                                images={userImages}
                                taxonomy={taxonomy}
                            />
                        )}
                    </div>
                </>
            )}
        </div>
    );
}
export default Tagging;
